import React from 'react'
import ReactDOM from 'react-dom/client'
import { SDKProvider } from '@tma.js/sdk-react'
import { AppRoot } from '@telegram-apps/telegram-ui'
import { BrowserRouter } from 'react-router-dom'
import App from './App.tsx'
import { setupTelegramApp } from './utils/telegram.ts'
import './i18n/index.ts'
import './index.css'

setupTelegramApp()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <SDKProvider acceptCustomStyles>
      <AppRoot>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </AppRoot>
    </SDKProvider>
  </React.StrictMode>,
)
